const templateProps = (route) => ({
  templateID: route.params.templateID,
})

const agreementProps = (route) => ({
  agreementID: route.params.agreementID,
  templateID: route.params.templateID,
})

const AgreementNew = () => import('src/pages/Agreement/New.vue')
const AgreementEdit = () => import('src/pages/Agreement/Edit.vue')
const AgreementList = () => import('src/pages/Agreement/List.vue')
const AgreementDefault = () => import('src/pages/Agreement/Blank.vue')
const AgreementLayout = () => import('src/pages/Agreement/Layout.vue')

export default {
  path: '/agreements',
  component: AgreementLayout,
  children: [
    {
      path: '',
      name: 'Agreement Default',
      components: AgreementDefault,
    },
    {
      meta: {
        subheader: '동의서 조회',
      },
      path: ':templateID',
      name: 'New Agreement List',
      component: AgreementList,
      props: templateProps,
    },
    {
      meta: {
        subheader: '동의서 생성',
      },
      path: ':templateID/new',
      name: 'New Agreement',
      component: AgreementNew,
      props: templateProps,
    },
    {
      meta: {
        subheader: '동의서 편집',
      },
      path: ':templateID/:agreementID',
      name: 'Edit Agreement',
      component: AgreementEdit,
      props: agreementProps,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/routes/agreement.js